import React from 'react';

const Vue_is_Attribute = () => {
  return (
    <div>
      <h1>Vue_is_Attribute Component</h1>
      <p>This is the Vue_is_Attribute tutorial page.</p>
    </div>
  );
}

export default Vue_is_Attribute;
